import React, { useState } from "react";
import StarCKYCForm from "./SearchKYC/StarCKYCForm";
import GenerateRefId from "./GenerateRef/GenerateRefId";
// import { RefIdContextProvider } from "./Context/RefIdContext";

function StarHealthKYC(props) {
  const [next, setNext] = useState(false);
  const [ckycId, setckycId] = useState(null);
  const [isCKYCVerified,setCKYCVerified] = useState(false);
  const { decryptedResponseId, decryptedAcuvisor_product_id,setParentNext,kyc_configId,a_id } = props;

  return (
    // <RefIdContextProvider>
      <div>
        {!next ? (
          <StarCKYCForm
            setNext={setNext}
            setckycId = {setckycId}
            setCKYCVerified={setCKYCVerified}
            decryptedResponseId={decryptedResponseId}
            decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
            a_id = {a_id}
          />
        ) : (
          <GenerateRefId 
          setParentNext = {setParentNext}
          kyc_configId={kyc_configId}
          a_id={a_id}
          ckycId = {ckycId}
          isCKYCVerified={isCKYCVerified}
          setCKYCVerified={setCKYCVerified}
          decryptedResponseId={decryptedResponseId} />
        )}
      </div>
    // </RefIdContextProvider>
  );
}

export default StarHealthKYC;
